import * as React from 'react';
import { Layout } from '../components/layout';
import { Resultado } from '../pages/resultado/resultado';
import { Validacao } from '../pages/validacao/validacao';
import { CertificadoNaoEncontrado } from '../pages/resultado/certificado-nao-encontrado';

const headerProps = {
  name: 'Certificados'
};

export const PublicRoutes = [
  {
    routePath: '/',
    isExactPath: true,
    pageToRender: (
      <Layout headerProps={headerProps}>
        <Validacao />
      </Layout>
    ),
  },
  {
    routePath: '/resultado/:id',
    isExactPath: true,
    pageToRender: (
      <Layout headerProps={headerProps}>
        <Resultado />
      </Layout>
    ),
  },
  {
    routePath: '/error/certificado-nao-localizado',
    isExactPath: true,
    pageToRender: (
      <Layout headerProps={headerProps}>
        <CertificadoNaoEncontrado />
      </Layout>
    ),
  },
];
